import { Flex, Stack, TextInput } from "@mantine/core";
import { CloseOutlined, SearchOutlined } from "@mui/icons-material";
import { SvgIcon } from "@mui/material";
import { FC } from "react";
import {
    GlobalReferralFilterButton,
    GlobalReferralFilterPills
} from "./GlobalReferralFilters";
import { GlobalReferralFilterState } from "./useGlobalReferralFilters";

type GlobalReferralHeaderProps = {
    search: string;
    setSearch: (search: string) => void;
    filters: GlobalReferralFilterState;
    setFilters: (filters: GlobalReferralFilterState) => void;
};

export const GlobalReferralHeader: FC<GlobalReferralHeaderProps> = ({
    search,
    setSearch,
    filters,
    setFilters
}) => {
    return (
        <Stack gap="xs">
            <Flex justify="space-between" align="center">
                <Flex flex={1} gap="sm" align="center">
                    <TextInput
                        data-testid="search.bar.input"
                        placeholder="Search global referrals..."
                        leftSection={<SvgIcon component={SearchOutlined} />}
                        value={search}
                        onChange={(e) => setSearch(e.currentTarget.value)}
                        rightSection={
                            search ? (
                                <SvgIcon
                                    component={CloseOutlined}
                                    sx={{
                                        width: "0.9rem",
                                        height: "0.9rem",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => setSearch("")}
                                />
                            ) : null
                        }
                    />
                    <GlobalReferralFilterButton
                        filters={filters}
                        setFilters={setFilters}
                    />
                </Flex>
                <Flex flex={1} justify="flex-end" />
            </Flex>
            <GlobalReferralFilterPills
                filters={filters}
                setFilters={setFilters}
            />
        </Stack>
    );
};
